<template>
    <AppAgent />
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import APPS from '@generio-ai/library-legacy/constants/apps'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AppAgent from '@/components/agent/AppAgent.vue'

export default {
    name: 'ViewAgent',
    components: {
        AppAgent
    },
    computed: {
        app() {
            return APPS.AGENT
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
    },
    mounted() {
        this.hide()
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Agent view opened',
        })
    }
}
</script>